import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import SmallLabel from "components/atoms/text/labels/SmallLabel";
import TRIANGLE_WARNING_RED from "assets/icons/triangle_warning_red.svg";
import StorageBar from "./StorageBar";
import TinyButton from "components/atoms/buttons/TinyButton";

import { AiOutlineSetting } from "react-icons/ai";
import { useAppSelector } from "redux/hooks";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { useMenu } from "hook/useMenu";
import useStorageUsage from "hook/useStorageUsage";

export interface StorageProps {
  totalStorage: number;
  usedStorage: number;
}

const StorageLabel = () => {
  const { percentage } = useStorageUsage();
  const { debouncedNavigate } = useMenu({});
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  return (
    <>
      <Container>
        <SmallLabel
          label="STORAGE"
          color={COLORS.PRIMARY1}
          icon={percentage >= 90 ? TRIANGLE_WARNING_RED : null}
        />

        <div>
          <StorageBar />
        </div>

        {selectedAccount.accountLevel === LEVEL_TYPE.EU &&
          selectedAccount.isAdminGroup &&
          percentage >= 90 && (
            <TinyButton
              label="Buy"
              buttonType="save"
              icon={<AiOutlineSetting color={COLORS.WHITE} size={15} />}
              onClickBtn={() =>
                debouncedNavigate({
                  to: "/subscription/organization/history",
                })
              }
              data-testid="blocks-storage-storage-tiny-button-debounced-navigate"
            />
          )}
      </Container>
    </>
  );
};

const Container = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 6px;
  width: 100%;
  div {
    width: 100%;
    /* min-width: 250px; */
  }
`;

export default StorageLabel;
